import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './filterMessages';

class SearchFilter extends Component {
  state = {
    value: '',
  };

  componentDidMount() {
    const { initialValue } = this.props;
    this.setState(state => ({
      ...state,
      value: initialValue || '',
    }));
  }

  handleClear() {
    this.setState(state => ({
      ...state,
      value: '',
    }));
  }

  handleInputChange(e) {
    this.setState({ value: e.target.value });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      const { value } = this.state;
      const { onFilter } = this.props;

      onFilter({ searchValue: value });
    }
  }

  render() {
    const { value } = this.state;
    const { onFilter, isFiltered, intl } = this.props;

    return (
      <div>
        <input
          className="form-control"
          placeholder={intl.formatMessage(messages.Search)}
          value={value}
          onChange={e => this.handleInputChange(e)}
          onKeyPress={e => this.handleKeyPress(e)}
          autoFocus
        />
        <button
          type="button"
          className="btn btn-inverse btn-block btn-sm margin10T"
          onClick={() => onFilter({ searchValue: value })}
        >
          {intl.formatMessage(messages.Filter)}
        </button>
        {isFiltered && (
          <button
            type="button"
            className="btn btn-default btn-sm margin10T"
            onClick={() => onFilter({ searchValue: '' })}
          >
            <i className="fa fa-times" />
            &nbsp;
            <span>{intl.formatMessage(messages.ClearFilter)}</span>
          </button>
        )}
      </div>
    );
  }

  static propTypes = {
    initialValue: PropTypes.string,
    /** Function to execute when a value has been entered and search has been requested */
    onFilter: PropTypes.func.isRequired,
    /** Boolean indicating whether a value is currently being filtered. Used for displaying a clear filter button  */
    isFiltered: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    initialValue: '',
    isFiltered: false,
  };
}

export default SearchFilter;
